import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/AboutUs/Banner';
import Values from '../Components/Pages/AboutUs/Values';
import Header from '../Components/Shared/Header/Header';
import InnovativePart from '../Components/Pages/Home/Innovative';
import Enjoy from '../Components/Pages/AboutUs/Enjoy';
import Care from '../Components/Pages/AboutUs/Care';
import Jobs from '../Components/Pages/AboutUs/Jobs';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function AboutUs(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Values />
        <InnovativePart />
        <Enjoy />
        <Care />
        <Jobs />
        <Start/>
        <Footer />
        </>
    )
};
export default AboutUs ;